export default "__VITE_ASSET__CnQf_ile__"